// Display formatting. Money helpers come from @convenor/shared (formatEur etc.).
import { dayMonthYearShort, formatFixed } from "@convenor/shared";
export { formatEur, formatHalves, formatNumber } from "@convenor/shared";

const longDate = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" });
const dateTime = new Intl.DateTimeFormat("en-GB", {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

const toDate = (v: string) => (/^\d{4}-\d{2}-\d{2}$/.test(v) ? new Date(`${v}T00:00:00Z`) : new Date(v));

/** "12 Mar 2026" (tables). Accepts "YYYY-MM-DD" or an ISO timestamp. X-18: "Sep", never "Sept" (the shared month list). */
export const formatDate = (v: string | null | undefined): string => (v ? dayMonthYearShort(toDate(v).toISOString()) : "");

/** "12 March 2026" (documents). */
export const formatDateLong = (v: string | null | undefined): string => (v ? longDate.format(toDate(v)) : "");

/** "12 Mar 2026, 14:05" in the viewer's time zone. */
export const formatDateTime = (v: string | null | undefined): string => (v ? dateTime.format(new Date(v)).replace(/\bSept\b/, "Sep") : "");

/** "12 Mar 2026 to 30 Sep 2029", "12 Mar 2026", or "" */
export function formatPeriod(start: string | null, end: string | null): string {
  if (start && end && start !== end) return `${formatDate(start)} to ${formatDate(end)}`;
  return formatDate(start ?? end);
}

/** 1 -> "1 day", 9 -> "9 days" */
export const formatDays = (n: number): string => `${n} ${n === 1 ? "day" : "days"}`;

/** 2.5 -> "2,5", 3 -> "3" (half-unit quantities, for display; inputs keep `String(n)`). */
export const formatQuantity = (n: number): string => (Number.isInteger(n) ? String(n) : formatFixed(n));

/** "2,5" or "2.5" -> 2.5; "" -> null; anything else -> NaN. */
export function parseQuantity(input: string): number | null {
  const s = input.trim().replace(",", ".");
  if (s === "") return null;
  if (!/^\d+(\.\d+)?$/.test(s)) return Number.NaN;
  return Number(s);
}

/** "Ana Silva" -> "Ana" */
export const firstName = (name: string): string => name.trim().split(/\s+/)[0] ?? name;
